import { Button, clx, icon } from "@hm/fundamental"

interface MultiselectSearchProps {
	searchInputRef: React.Ref<HTMLInputElement>
	searchQuery: string
	placeholder: string
	onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	onKeyDown: (event: React.KeyboardEvent) => void
	onClose: () => void
	searchAriaLabel: string
	closeAriaLabel: string
	"data-cy": string
}

export const MultiselectSearch: React.FC<MultiselectSearchProps> = ({
	searchInputRef,
	searchQuery,
	placeholder,
	onSearchChange,
	onKeyDown,
	onClose,
	searchAriaLabel,
	closeAriaLabel,
	"data-cy": dataCy,
}) => {
	return (
		<div
			className={clx(
				"flex items-center gap-2 w-full h-12 rounded-lg border border-solid px-4 text-base",
				"border-border_highlight bg-container_background",
			)}
			data-cy={`${dataCy}-search-wrapper`}
		>
			<input
				ref={searchInputRef}
				type="text"
				className="w-full bg-transparent text-base outline-none placeholder:text-foreground_faded"
				placeholder={placeholder}
				value={searchQuery}
				onChange={onSearchChange}
				onKeyDown={onKeyDown}
				aria-label={searchAriaLabel}
				data-cy={`${dataCy}-search`}
			/>
			<Button
				square
				variant="tertiary"
				icon={icon.mdiChevronUp}
				onClick={onClose}
				aria-label={closeAriaLabel}
				data-cy={`${dataCy}-close`}
			/>
		</div>
	)
}
